// extracted by mini-css-extract-plugin
module.exports = {"projects_container":"projects_projects_container__MB6Jp","work_container":"projects_work_container__15uiN","education_container":"projects_education_container__2ygvo"};